import React, { ElementType, FC, ReactNode } from "react";
import DMWomenFlyout from "../templates/Menu/FlyoutMenus/DMWomenFlyout";

export const MenFlyoutContent: FC = () => {
  return <div>Content men</div>;
};

export const KidsFlyoutContent: FC = () => {
  return <div>Content kids</div>;
};

export const mockedGenderOptions: Array<{
  text: ReactNode;
  id: string;
  content: ElementType | React.ElementType;
}> = [
  {
    id: "women",
    text: "women",
    content: DMWomenFlyout,
  },
  {
    id: "men",
    text: "men",
    content: MenFlyoutContent,
  },
  {
    id: "kids",
    text: "kids",
    content: KidsFlyoutContent,
  },
];
